<template>
  <div class="dg__copyright text-center t-[12]">
    <p class="t-[#B7B9BE]">
      <span class="pb-[4] table-cell t-[12] border-b-[1] border-[#D5DAE5] border-solid">
        <!-- <img src="@/assets/img/fa.svg" alt="" class="aui-middle"> -->
        <span class="aui-middle">声明：本平台仅提供技术支持，所有保函产品均由保函下发金融机构提供，销售、理赔等服务均由本平台合作的金融机构提供</span>
      </span>
    </p>
    <div class="">
      <p class="t-[#909399] pb-4 pt-[8] leading-[20] t-[12]">
        <span v-html="conf.organizer"></span>
        <img src="@/assets/img/gov.png" width="16" alt="">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="!t-[theme] set-a">{{conf.beiAn}}</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "dg-copyright",
  props: {
    positionType: {
      type: String,
      default: "absolute",
    },
    setStyle: {
      type: Object,
      default: () => {
        return {
          paddingTop: "16px",
          paddingBottom: "16px",
        };
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>
<style lang="less" scoped>
@import '~@/assets/css/var.less';</style>
 <style>.t-\[12\] {
    font-size: 12px
}
.t-\[\#B7B9BE\] {
    color: #B7B9BE
}
.pb-\[4\] {
    padding-bottom: 4px
}
.border-b-\[1\] {
    border-bottom-width: 1px
}
.border-\[\#D5DAE5\] {
    border-color: #D5DAE5
}
.t-\[\#909399\] {
    color: #909399
}
.pt-\[8\] {
    padding-top: 8px
}
.leading-\[20\] {
    line-height: 20px
}
.\!t-\[theme\] {
    color: #008AA6 !important
}
.text-center {
    text-align: center
}
.table {
    display: table
}
.border-solid {
    border-style: solid
}</style>